const PAYMENT_URL = "https://hotmart.com/es/marketplace/productos/el-mapa-del-trauma/E106711470B";

export function Header() {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="container header-inner">
        <a href="/" className="logo-link" data-testid="site-logo" aria-label="Cristina Vidal Psicóloga">
          <img src="/assets/logo.png" alt="Cristina Vidal · Psicóloga" className="logo-img" />
        </a>
        <a href={PAYMENT_URL} className="btn btn-small" data-testid="header-cta-button">
          Quiero aprender a leer el mapa
        </a>
      </div>
    </header>
  );
}

export function Hero() {
  return (
    <section className="hero" data-testid="hero-section">
      <div className="container hero-grid">
        <div className="hero-left">
          <p className="eyebrow fade-up d1">Formación para profesionales de la salud mental</p>
          <h1 className="hero-title fade-up d2" data-testid="hero-title">El mapa del trauma</h1>
          <p className="hero-subtitle fade-up d3">La formación que te enseña a pensar antes de intervenir.</p>
          <p className="hero-text fade-up d4">
            Aprende a comprender qué necesita realmente cada paciente antes de decidir cómo intervenir.
          </p>
          <div className="fade-up d5">
            <a href={PAYMENT_URL} className="btn" data-testid="hero-cta-button">Quiero aprender a leer el mapa</a>
          </div>
          <ul className="hero-meta fade-up d6" data-testid="hero-meta">
            <li><strong>3</strong> casos clínicos</li>
            <li><strong>3</strong> bonus exclusivos</li>
            <li>Un mapa para <strong>cualquier orientación terapéutica</strong></li>
          </ul>
        </div>
        <div className="hero-right fade-up d3">
          <figure className="hero-photo" data-testid="hero-photo">
            <img src="/assets/cristina.webp" alt="Cristina Vidal, psicóloga" />
          </figure>
        </div>
      </div>
    </section>
  );
}

const MEDIOS = [
  { src: "/assets/medios/lavanguardia.jpg", alt: "La Vanguardia" },
  { src: "/assets/medios/eldiario.png", alt: "elDiario.es" },
  { src: "/assets/medios/menshealth.jpg", alt: "Men's Health" },
  { src: "/assets/medios/theobjective.jpg", alt: "The Objective" },
  { src: "/assets/medios/elconfidencial.jpg", alt: "El Confidencial" },
];

export function MediaStrip() {
  return (
    <section className="media-strip" data-testid="media-strip">
      <div className="container">
        <p className="media-label">Colaboraciones y medios en los que ha aparecido Cristina</p>
        <div className="media-logos">
          {MEDIOS.map((m, i) => (
            <img src={m.src} alt={m.alt} key={i} loading="lazy" />
          ))}
        </div>
      </div>
    </section>
  );
}

const NODES = [
  "¿Seguridad?",
  "¿Regulación?",
  "¿Comprender lo que le ocurre?",
  "¿Procesar el trauma?",
  "¿O simplemente alguien que todavía no la empuje a mirar hacia atrás?",
];

export function Question() {
  return (
    <section className="question-section" data-testid="question-section">
      <div className="container question-layout">
        <div className="question-copy reveal">
          <p className="question-intro">
            Hay algo que casi todos los terapeutas descubren cuando empiezan a trabajar con trauma.
          </p>
          <p className="question-lines">
            No basta con escuchar.<br />
            No basta con conocer una técnica.<br />
            Y tampoco basta con haber hecho muchos cursos.
          </p>
          <p className="question-lead">
            Porque llega un momento en el que aparece una pregunta que ningún protocolo responde por ti.
          </p>
          <h2 className="question-big" data-testid="question-headline">¿Qué necesita realmente esta persona <em>hoy</em>?</h2>
          <div className="nodes" data-testid="needs-nodes">
            {NODES.map((n, i) => (
              <span className="node" key={i}>
                <i className="node-dot" aria-hidden="true" />
                {n}
              </span>
            ))}
          </div>
          <p className="question-close">Este curso nace para responder precisamente a esa pregunta.</p>
          <p className="question-after">
            No importa si es tu primer contacto con el trauma o si ya llevas años formándote.
            Aprenderás a ver el mapa completo antes de decidir qué camino recorrer.
          </p>
        </div>
        <div className="question-visual reveal" aria-hidden="true" />
      </div>
    </section>
  );
}

const DOUBTS = [
  "¿Voy demasiado deprisa?",
  "¿Estoy cronificando el problema?",
  "¿Estoy regulando demasiado?",
  "¿Estoy evitando el trauma?",
  "¿Y si hoy esta persona necesitaba algo completamente distinto?",
];

export function Vocation() {
  return (
    <section className="vocation-section" data-testid="vocation-section">
      <div className="container">
        <p className="eyebrow reveal">Nunca fue un problema de vocación</p>
        <div className="vocation-grid">
          <div className="vocation-left reveal">
            <p className="vocation-statement">Te has formado para ayudar.</p>
            <p className="vocation-statement">Sabes crear vínculo.</p>
            <p className="vocation-statement">Sabes escuchar.</p>
            <p className="vocation-statement">Sabes sostener el sufrimiento.</p>
            <p className="vocation-but">
              Pero cuando aparece el trauma… muchos terapeutas sienten que el mapa desaparece.
              <br />Empiezan las dudas.
            </p>
          </div>
          <div className="vocation-right reveal">
            <div className="doubt-card" data-testid="doubts-card">
              {DOUBTS.map((d, i) => (
                <p className="doubt-line" key={i}>{d}</p>
              ))}
            </div>
          </div>
        </div>
        <div className="vocation-bottom reveal">
          <p>No son dudas de incompetencia.</p>
          <p>Son dudas de quien entiende la enorme responsabilidad que implica trabajar con personas heridas.</p>
          <p>Y tener dudas no significa que seas peor terapeuta.</p>
          <p className="vocation-highlight">Significa que necesitas una manera distinta de mirar.</p>
        </div>
      </div>
    </section>
  );
}

export function QuoteSection() {
  return (
    <section className="quote-section" data-testid="quote-section">
      <div className="container center">
        <p className="eyebrow reveal">Imagina terminar una sesión pensando…</p>
        <blockquote className="main-quote reveal" data-testid="main-quote">
          «No sé exactamente qué técnica utilizaré la próxima vez…
          <span> pero sí sé qué necesita esta persona.»</span>
        </blockquote>
        <div className="quote-after reveal">
          <p>Ese cambio transforma completamente la práctica clínica.</p>
          <p>
            Porque cuando entiendes el mapa… la incertidumbre disminuye.
            Las decisiones empiezan a tener sentido.
            Y la terapia deja de depender de la improvisación.
          </p>
        </div>
      </div>
    </section>
  );
}

const RESULTS = [
  {
    t: "Comprender el trauma",
    d: "Comprenderás qué es realmente el trauma y cómo diferenciarlo de otras formas de sufrimiento.",
  },
  {
    t: "Identificar el momento",
    d: "Sabrás identificar cuándo una persona necesita regulación, cuándo necesita comprender y cuándo puede empezar un procesamiento terapéutico.",
  },
  {
    t: "Adaptar la intervención",
    d: "Aprenderás a adaptar la intervención a cada paciente, en lugar de intentar adaptar al paciente a una técnica.",
  },
  {
    t: "Ganar seguridad",
    d: "Ganarás seguridad para tomar decisiones clínicas complejas.",
  },
  {
    t: "Un mapa mental propio",
    d: "Desarrollarás un mapa mental que podrás utilizar con cualquier orientación terapéutica.",
  },
];

export function Results() {
  return (
    <section className="results-section" data-testid="results-section">
      <div className="container">
        <p className="eyebrow reveal">Cuando termines este curso…</p>
        <h2 className="section-title reveal">¿Qué vas a conseguir?</h2>
        <div className="results-grid" data-testid="results-grid">
          {RESULTS.map((r, i) => (
            <article className="result-card reveal" key={i} data-testid={`result-card-${i + 1}`}>
              <span className="card-number">0{i + 1}</span>
              <h3>{r.t}</h3>
              <p>{r.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
